module.exports = __webpack_public_path__ + "media/images/proof_links/colored/megogo-017ebaef7a59588459d570a62ec6d138.svg";